"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'orderDetail',
  components: {},
  data: function data() {
    return {
      detailDialog: false,
      flow: [],
      info: {
        agents_profit: []
      },
      xiyiji_fee_plan: {},
      washRefund: {},
      refundStatus: {
        1: '申请中',
        2: '已拒绝',
        3: '已通过',
        4: '已退款'
      }
    };
  },
  mounted: function mounted(options) {
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('wxapi/order_detail', {
        order_id: this.$route.query.order_id
      }).then(function (res) {
        _this.flow = res.operate_flow;
        _this.info = res.order_info;
        _this.xiyiji_fee_plan = res.xiyiji_fee_plan;
        _this.refundInfo(res.order_info.order_id);
      });
    },
    /**
     * 退款详情
     */
    refundInfo: function refundInfo() {
      var _this2 = this;
      this.$get('wxapi/order/order_refund_appy_detail', {
        order_id: this.$route.query.order_id
      }).then(function (res) {
        _this2.washRefund = res[0] || {};
      });
    }
  }
};